import React from 'react'

function Download() {
  return (
<div className="download_area">
  <div className="container">
    <div className="row">
      <div className="col-xl-10">
        <div className="download_text">
          <h3>I’m a Software Engineer based in Owerri Imo Nigeria, who loves clean, simple &amp; reusable code. </h3>
        </div>
      </div>
    </div>
    <div className="row">
      <div className="col-lg-6 col-md-6">
        <div className="download_left">
          <p>I am a software engineer Enthusiastic about working with multicultural teams, and
            effective at working with python and javascript technologies as well as being
            focused on solving customer problems, improving usability and maximizing efficiency.
          </p>
          <p>I can work proficiently on the web platform and continuously adapt to techniques that
            make user reports better while meeting up with commercial and enterprise desires and 
            standards.
          </p>
          <a className="boxed-btn3-line" href="Nnadidan_Fullstack.pdf" download="Nnadidan_Fullstack.pdf">Download CV</a>
        </div>
      </div>
      <div className="col-lg-5 offset-lg-1 col-md-6">
        <div className="progress_skills">
          <div className="single_progress">
            <div className="label d-flex justify-content-between">
              <span>Html</span>
              <span>99%</span>
            </div>
            <div className="progress">
              <div className="progress-bar " role="progressbar" style={{width: '99%'}} aria-valuenow={25} aria-valuemin={0} aria-valuemax={100} />
            </div>
          </div>
          <div className="single_progress">
            <div className="label d-flex justify-content-between">
              <span>Css</span>
              <span>99%</span>
            </div>
            <div className="progress">
              <div className="progress-bar " role="progressbar" style={{width: '99%'}} aria-valuenow={25} aria-valuemin={0} aria-valuemax={100} />
            </div>
          </div>
          <div className="single_progress">
            <div className="label d-flex justify-content-between">
              <span>JavaScript</span>
              <span>99%</span>
            </div>
            <div className="progress">
              <div className="progress-bar" role="progressbar" style={{width: '99%'}} aria-valuenow={25} aria-valuemin={0} aria-valuemax={100} />
            </div>
          </div>
          <div className="single_progress">
            <div className="label d-flex justify-content-between">
              <span>Styled-Components, Tailwind css</span>
              <span>90%</span>
            </div>
            <div className="progress">
              <div className="progress-bar" role="progressbar" style={{width: '90%'}} aria-valuenow={25} aria-valuemin={0} aria-valuemax={100} />
            </div>
          </div>

          <div className="single_progress">
            <div className="label d-flex justify-content-between">
              <span>React</span>
              <span>90%</span>
            </div>
            <div className="progress">
              <div className="progress-bar" role="progressbar" style={{width: '90%'}} aria-valuenow={25} aria-valuemin={0} aria-valuemax={100} />
            </div>
          </div>
          <div className="single_progress">
            <div className="label d-flex justify-content-between">
              <span>Node.Js</span>
              <span>90%</span>
            </div>
            <div className="progress">
              <div className="progress-bar" role="progressbar" style={{width: '90%'}} aria-valuenow={25} aria-valuemin={0} aria-valuemax={100} />
            </div>
          </div>
          
          <div className="single_progress">
            <div className="label d-flex justify-content-between">
              <span>Express</span>
              <span>90%</span>
            </div>
            <div className="progress">
              <div className="progress-bar" role="progressbar" style={{width: '90%'}} aria-valuenow={25} aria-valuemin={0} aria-valuemax={100} />
            </div>
          </div>
          <div className="single_progress">
            <div className="label d-flex justify-content-between">
              <span>Next.js</span>
              <span>90%</span>
            </div>
            <div className="progress">
              <div className="progress-bar" role="progressbar" style={{width: '90%'}} aria-valuenow={25} aria-valuemin={0} aria-valuemax={100} />
            </div>
          </div>
          <div className="single_progress">
            <div className="label d-flex justify-content-between">
              <span>Typescript</span>
              <span>90%</span>
            </div>
            <div className="progress">
              <div className="progress-bar" role="progressbar" style={{width: '90%'}} aria-valuenow={25} aria-valuemin={0} aria-valuemax={100} />
            </div>
          </div>
          <div className="single_progress">
            <div className="label d-flex justify-content-between">
              <span>MonGoDB</span>
              <span>90%</span>
            </div>
            <div className="progress">
              <div className="progress-bar" role="progressbar" style={{width: '90%'}} aria-valuenow={25} aria-valuemin={0} aria-valuemax={100} />
            </div>
          </div>

          <div className="single_progress">
            <div className="label d-flex justify-content-between">
              <span>SQL, POstgres, Mysql, Sequelize</span>
              <span>90%</span>
            </div>
            <div className="progress">
              <div className="progress-bar" role="progressbar" style={{width: '90%'}} aria-valuenow={25} aria-valuemin={0} aria-valuemax={100} />
            </div>
          </div>

          <div className="single_progress">
            <div className="label d-flex justify-content-between">
              <span>Python(DjanGo)</span>
              <span>90%</span>
            </div>
            <div className="progress">
              <div className="progress-bar" role="progressbar" style={{width: '90%'}} aria-valuenow={25} aria-valuemin={0} aria-valuemax={100} />
            </div>
          </div>
          <div className="single_progress">
            <div className="label d-flex justify-content-between">
              <span>Python(Flask)</span>
              <span>90%</span>
            </div>
            <div className="progress">
              <div className="progress-bar" role="progressbar" style={{width: '90%'}} aria-valuenow={25} aria-valuemin={0} aria-valuemax={100} />
            </div>
          </div>
          <div className="single_progress">
            <div className="label d-flex justify-content-between">
              <span>Firebase</span>
              <span>90%</span>
            </div>
            <div className="progress">
              <div className="progress-bar" role="progressbar" style={{width: '90%'}} aria-valuenow={25} aria-valuemin={0} aria-valuemax={100} />
            </div>
          </div>
          <div className="single_progress">
            <div className="label d-flex justify-content-between">
              <span>GCP(Google Cloud Platform)</span>
              <span>90%</span>
            </div>
            <div className="progress">
              <div className="progress-bar" role="progressbar" style={{width: '90%'}} aria-valuenow={25} aria-valuemin={0} aria-valuemax={100} />
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</div>

  )
}

export default Download